import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import HorizontalScrollBar from './HorizontalScrollBar';
import Loader from '../components/Loader';
import bg from '../assets/images/bg1.jpeg';

const SimilarExercises = ({ targetMuscleExercises, equipmentExercises }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="svg"
      >
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L26.7,202.7C53.3,181,107,139,160,117.3C213.3,96,267,96,320,128C373.3,160,427,224,480,234.7C533.3,245,587,203,640,170.7C693.3,139,747,117,800,122.7C853.3,128,907,160,960,186.7C1013.3,213,1067,235,1120,256C1173.3,277,1227,299,1280,277.3C1333.3,256,1387,192,1413,160L1440,128L1440,320L1413.3,320C1386.7,320,1333,320,1280,320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"
        ></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L26.7,202.7C53.3,181,107,139,160,117.3C213.3,96,267,96,320,128C373.3,160,427,224,480,234.7C533.3,245,587,203,640,170.7C693.3,139,747,117,800,122.7C853.3,128,907,160,960,186.7C1013.3,213,1067,235,1120,256C1173.3,277,1227,299,1280,277.3C1333.3,256,1387,192,1413,160L1440,128L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"
        ></path>
      </svg>
      <Box sx={{ mt: { lg: '-50px', xs: '0px' } }}>
        <Typography
          variant="h2"
          color="#ff2625"
          align="center"
          fontWeight={500}
          mb={8}
          className="h2Demo"
        >
          <span style={{ color: '#fff' }}>Exercises</span> demo
          <pan style={{ color: '#fed136' }}>.</pan>
        </Typography>

        <Stack direction="row" sx={{ p: '2', position: 'relative' }}>
          {targetMuscleExercises.length ? (
            <HorizontalScrollBar data={targetMuscleExercises} />
          ) : (
            <Loader />
          )}
        </Stack>

        <Typography
          className="h2Demo"
          variant="h3"
          color="#ff2625"
          align="center"
          mt={14}
          mb={8}
        >
          <span style={{ color: '#fff' }}>Equipment</span> examples
          <pan style={{ color: '#fed136' }}>.</pan>
        </Typography>

        <Stack direction="row" sx={{ p: '2', position: 'relative' }}>
          {equipmentExercises.length ? (
            <HorizontalScrollBar data={equipmentExercises} />
          ) : (
            <Loader />
          )}
        </Stack>
      </Box>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="svg"
      >
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L26.7,202.7C53.3,181,107,139,160,117.3C213.3,96,267,96,320,128C373.3,160,427,224,480,234.7C533.3,245,587,203,640,170.7C693.3,139,747,117,800,122.7C853.3,128,907,160,960,186.7C1013.3,213,1067,235,1120,256C1173.3,277,1227,299,1280,277.3C1333.3,256,1387,192,1413,160L1440,128L1440,320L1413.3,320C1386.7,320,1333,320,1280,320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"
        ></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,224L26.7,202.7C53.3,181,107,139,160,117.3C213.3,96,267,96,320,128C373.3,160,427,224,480,234.7C533.3,245,587,203,640,170.7C693.3,139,747,117,800,122.7C853.3,128,907,160,960,186.7C1013.3,213,1067,235,1120,256C1173.3,277,1227,299,1280,277.3C1333.3,256,1387,192,1413,160L1440,128L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"
        ></path>
      </svg>

      <img className="bg" src={bg} alt="bg" />
    </>
  );
};

export default SimilarExercises;
